module.exports = __webpack_public_path__ + "img/logo-participaties.4154682.svg";